/* Desktop mega menu: hover-intent, menu-aim, keyboard, Esc, backdrop */
(function () {
  var root = document.documentElement;
  var items = Array.prototype.slice.call(document.querySelectorAll('[data-mega-item]'));
  var backdrop = document.querySelector('[data-mega-backdrop]');
  if (!items.length) return;
  root.classList.add('fadu-mega-js');

  var OPEN_DELAY = 90;    // first open: ignore fly-overs
  var SWITCH_DELAY = 220; // pointer heading down into the open panel: don't switch yet
  var CLOSE_DELAY = 200;
  var openTimer = null;
  var switchTimer = null;
  var closeTimer = null;
  var trail = [];

  document.addEventListener('mousemove', function (e) {
    trail.push({ x: e.clientX, y: e.clientY });
    if (trail.length > 4) trail.shift();
  }, { passive: true });

  /* Menu-aim: is the pointer travelling downwards (towards the open panel)? */
  function headingIntoPanel() {
    if (trail.length < 2) return false;
    var a = trail[0];
    var b = trail[trail.length - 1];
    var dy = b.y - a.y;
    var dx = Math.abs(b.x - a.x);
    return dy > 1 && dy >= dx * 0.12;
  }

  function trigger(item) { return item.querySelector('.fadu-mega-trigger'); }
  function isOpen(item) { return item.classList.contains('is-open'); }
  function anyOpen() { return items.some(isOpen); }

  function setOpen(item, on) {
    item.classList.toggle('is-open', on);
    var t = trigger(item);
    if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
  }
  function syncBackdrop() {
    if (backdrop) backdrop.classList.toggle('is-visible', anyOpen());
  }
  function clearTimers() {
    clearTimeout(openTimer);
    clearTimeout(switchTimer);
    clearTimeout(closeTimer);
  }
  function closeAll() {
    clearTimers();
    items.forEach(function (i) { setOpen(i, false); });
    syncBackdrop();
  }
  function open(item) {
    clearTimers();
    items.forEach(function (i) { if (i !== item) setOpen(i, false); });
    setOpen(item, true);
    syncBackdrop();
  }

  items.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      clearTimeout(switchTimer);
      if (isOpen(item)) return;
      if (!anyOpen()) {
        openTimer = setTimeout(function () { open(item); }, OPEN_DELAY);
      } else if (headingIntoPanel()) {
        switchTimer = setTimeout(function () {
          if (item.matches(':hover')) open(item);
        }, SWITCH_DELAY);
      } else {
        open(item);
      }
    });
    item.addEventListener('mouseleave', function () {
      clearTimeout(openTimer);
      clearTimeout(switchTimer);
      closeTimer = setTimeout(function () {
        items.forEach(function (i) {
          if (!i.matches(':hover') && !(i.matches(':focus-within') && document.hasFocus())) setOpen(i, false);
        });
        syncBackdrop();
      }, CLOSE_DELAY);
    });
    item.addEventListener('focusin', function () { open(item); });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) {
        setOpen(item, false);
        syncBackdrop();
      }
    });
    /* Touch laptops / tablets in landscape: first tap opens, second follows the link */
    var t = trigger(item);
    if (t) {
      t.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: none)').matches && !isOpen(item)) {
          e.preventDefault();
          open(item);
        }
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openItem = items.filter(isOpen)[0];
    if (!openItem) return;
    closeAll();
    var t = trigger(openItem);
    if (t) t.focus();
  });
  document.addEventListener('click', function (e) {
    if (anyOpen() && !e.target.closest('[data-mega-item]')) closeAll();
  });
  window.addEventListener('resize', closeAll);
})();
